import { render, staticRenderFns } from "./Step4Lightbox.vue?vue&type=template&id=5288874e&lang=pug&"
import script from "./Step4Lightbox.vue?vue&type=script&lang=js&"
export * from "./Step4Lightbox.vue?vue&type=script&lang=js&"
import style0 from "./Step4Lightbox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../home/httpd/vhosts/tocin.com.tw/httpdocs/tocin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports